import { render, staticRenderFns } from "./RegistradoMarca.vue?vue&type=template&id=67f3e701&"
import script from "./RegistradoMarca.vue?vue&type=script&lang=js&"
export * from "./RegistradoMarca.vue?vue&type=script&lang=js&"
import style0 from "./RegistradoMarca.vue?vue&type=style&index=0&id=67f3e701&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports